"use strict";
exports.__esModule = true;
var clients_1 = require("../clients");
var XbedAPI = /** @class */ (function () {
    function XbedAPI(debug, config, interceptor) {
        this.xbedGatewayClient = new clients_1.XbedGatewayClient(debug, {
            gatewayUrl: config.gatewayUrl,
            edition: config.edition,
            goods: config.goods,
            terrace: config.terrace,
            xbedSecretToken: config.xbedSecretToken,
            xbedSecretKey: config.xbedSecretKey
        }, interceptor);
    }
    XbedAPI.prototype.setToken = function (token) {
        this.xbedGatewayClient.setToken(token);
    };
    XbedAPI.prototype.removeToken = function () {
        this.xbedGatewayClient.removeToken();
    };
    /**
     * 用户登录接口
     * @param phone 手机号码
     * @param password 验证码
     * @param source 来源，0-微信公众号，2-IOS，3-Android，4-微信小程序
     * @param openId 微信公众号ID
     */
    XbedAPI.prototype.login = function (params) {
        return this.xbedGatewayClient.login(params);
    };
    /**
     * 验证用户登录接口
     * @param source 来源，0-微信公众号，2-IOS，3-Android，4-微信小程序
     * @param openId 微信公众号ID
     */
    XbedAPI.prototype.openIdLogin = function (openId, source) {
        return this.xbedGatewayClient.openIdLogin(openId, source);
    };
    /**
     * 用户退出接口V2
     * @param source 渠道来源：0 - 微信公众号；1 - 去呼呼；2 - IOS；3 - Android；4 - OMS；5 - 携程；6 - 业主会；7 - 美团；8 - XBED；10 - 办理入住时系统注册；11 - 活动注册；12 - 预订时系统注册；14 - OTA；15 - wap；16 - www；17 - 长租
     * @param openId 微信openId
     */
    XbedAPI.prototype.logout = function (source, openId, token) {
        return this.xbedGatewayClient.logout(source, openId, token);
    };
    /**
     * 获取短信验证码
     * @param phone 手机号码
     * @param imgCode 用户输入的图片验证码
     * @param verifyCode 验证码标识
     */
    XbedAPI.prototype.getSMSCaptCha = function (phone, imgCode, verifyCode) {
        var isText = true;
        var params = {
            isText: isText,
            phone: phone
        };
        if (imgCode) {
            params.imgCode = imgCode;
        }
        if (verifyCode) {
            params.verifyCode = verifyCode;
        }
        return this.xbedGatewayClient.getVerificationCode(params);
    };
    /**
     * 获取语音验证码
     * @param phone 手机号码
     * @param imgCode 用户输入的图片验证码
     * @param verifyCode 验证码标识
     */
    XbedAPI.prototype.getVoiceCaptCha = function (phone, imgCode, verifyCode) {
        var isText = false;
        var params = {
            isText: isText,
            phone: phone
        };
        if (imgCode) {
            params.imgCode = imgCode;
        }
        if (verifyCode) {
            params.verifyCode = verifyCode;
        }
        return this.xbedGatewayClient.getVerificationCode(params);
    };
    /**
     * 查询用户收藏房间
     * @param page
     * @param size
     * @param token
     */
    XbedAPI.prototype.queryRoomCollectionList = function (page, size, token) {
        return this.xbedGatewayClient.getCollectRooms(page, size, token);
    };
    /**
     * 添加房间收藏
     * @param roomId 房间ID
     * @param rentType 租赁类型 1 - 表示短租；2 - 表示长租
     * @param token
     */
    XbedAPI.prototype.addRoomWithCollection = function (roomId, rentType, token) {
        return this.xbedGatewayClient.collectRoom(roomId, rentType, 1, token);
    };
    /**
     * 删除房间收藏
     * @param roomId 房间ID
     * @param rentType 租赁类型 1 - 表示短租；2 - 表示长租
     * @param token
     */
    XbedAPI.prototype.removeRoomWithCollection = function (roomId, rentType, token) {
        return this.xbedGatewayClient.collectRoom(roomId, rentType, 2, token);
    };
    /**
     * 查询用户收藏门店
     * @param page 当前页数
     * @param size 每页数量
     * @param token
     */
    XbedAPI.prototype.queryChainCollectionList = function (page, size, token) {
        return this.xbedGatewayClient.getUserCollectChain(page, size, token);
    };
    /**
     * 添加用户门店收藏夹
     * @param chainId 门店id
     * @param token
     */
    XbedAPI.prototype.addChainWithCollection = function (chainId, token) {
        // 1-添加收藏夹
        return this.xbedGatewayClient.collectChain(chainId, 1, token);
    };
    /**
     * 删除用户门店收藏夹
     * @param chainId 门店id
     * @param token
     */
    XbedAPI.prototype.removeChainWithCollect = function (chainId, token) {
        // 2-删除收藏夹
        return this.xbedGatewayClient.collectChain(chainId, 2, token);
    };
    /**
     * 查询房价日历
     * @param roomTypeId 	房型ID
     * @param token
     */
    XbedAPI.prototype.getRoomPriceCalendar = function (roomTypeId) {
        return this.xbedGatewayClient.getRoomPriceCalendar(roomTypeId);
    };
    /**
     * 房型详情页
     * @param roomTypeId 房型Id
     * @param token
     */
    XbedAPI.prototype.getRoomTypeDetail = function (startDate, endDate, roomTypeId) {
        return this.xbedGatewayClient.getRoomTypeInfo(startDate, endDate, roomTypeId);
    };
    /**
     * 房型预订页
     * @param startDate 入住日期
     * @param endDate 退房日期
     * @param roomTypeId 房型Id
     * @param token
     */
    XbedAPI.prototype.getRoomBooking = function (startDate, endDate, roomTypeId) {
        return this.xbedGatewayClient.getRoomBooking(startDate, endDate, roomTypeId);
    };
    /**
     * 查询房型剩余房量
     * @param startDate 入住日期
     * @param endDate 退房日期
     * @param roomTypeId 房型Id
     * @param token
     */
    XbedAPI.prototype.getRoomCount = function (startDate, endDate, roomTypeId) {
        return this.xbedGatewayClient.getRoomCount(startDate, endDate, roomTypeId);
    };
    /**
     * 门店详情页
     * @param channelHotelId 门店id
     * @param startDate 入住时间
     * @param endDate 退房时间
     * @param token
     */
    XbedAPI.prototype.getXbedChannelHotelInfo = function (channelHotelId, startDate, endDate, token) {
        return this.xbedGatewayClient.getXbedChannelHotelInfo(channelHotelId, startDate, endDate, token);
    };
    /**
     * 门店列表
     * @param bedCount 床数 (-1代表更多，不传代表不限,不限床数时，不用传该字段
     * @param bedroomNum 卧室数量 (-1代表更多，不传代表不限,不限床数时，不用传该字段)
     * @param city 城市（必传）
     * @param flag 是否需要加载搜索元素(必传)，0 不需要 1 需要
     * @param startDate 入住日期 yyyy-MM-dd
     * @param endDate 离店日期 yyyy-MM-dd
     * @param indiviTag 特色 (可多选)
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）*****如果这里是1 则前端隐藏isFull=1的门店
     * @param maxPrice 	价格最大值，单位分
     * @param minPrice 价格最小值，单位分
     * @param orderBy 默认排序，不用传该字段 (0价格从低到高；1价格从高到低)
     * @param page 页码
     * @param pageSize 每页记录数
     * @param position 位置
     * @param token
     */
    XbedAPI.prototype.queryXbedChannelHotelList = function (params) {
        return this.xbedGatewayClient.getXbedChannelHotelList(params);
    };
    /**
     * 打包房型-预定接口
     * @param arrivalTime 到达时间
     * @param beginDate 入住日期
     * @param endDate 离店日期
     * @param custName 客户姓名
     * @param orderPrice 订单总价（单位：分）
     * @param roomNum 房间数量
     * @param roomPrice 房费（单位：分）
     * @param roomTypeId 房型ID
     * @param totalPrice 应付金额 (单位：分)
     * @param token
     */
    XbedAPI.prototype.createChainOrder = function (params, token) {
        return this.xbedGatewayClient.createChainOrder(params, token);
    };
    /**
     * 计算房间价格
     * @param roomTypeId 房型Id
     * @param startDate 入住日期
     * @param endDate 退房日期
     * @param roomCount 房间数量
     * @param token
     */
    XbedAPI.prototype.getTotalPrice = function (roomTypeId, startDate, endDate, roomCount, isOpen, mobile) {
        return this.xbedGatewayClient.getTotalPrice(roomTypeId, startDate, endDate, roomCount, isOpen, mobile);
    };
    /**
     * 查询订单列表V2(增加房型打包后需要更新的订单列表接口)
     * @param type 0：全部 1：待支付 2：待入住 3：已入住 4：待评价
     * @param page
     * @param size
     * @param token
     */
    XbedAPI.prototype.queryOrderList = function (type, page, size, token) {
        return this.xbedGatewayClient.checkinList(type, page, size, token);
    };
    /**
     * 查询订单列表(增加艺龙接口数据)
     * @param status 0：全部 1：待支付 2：待入住 3：已入住 4：待评价 订单状态（必填）
     * @param page_num 页码大小（必填）
     * @param page_size 页码大小（必填）
     * @param user_id 用户id（必填）
     */
    XbedAPI.prototype.orderList = function (param, token) {
        return this.xbedGatewayClient.orderList(param, token);
    };
    /**
     * 查询收藏接口
     * @param page 当前页(必填)
     * @param page_size 	每页数据条数(必填)
     * @param user_id 	用户id(必填)
     */
    XbedAPI.prototype.getCollectList = function (page, pageSize, userId, token) {
        return this.xbedGatewayClient.getCollectList(page, pageSize, userId, token);
    };
    /**
     * addElongCollect 增加艺龙收藏
     * @param city_name 城市名（必填）	string
     * @param district_name 区县名（也建议填上）	string
     * @param hotel_id 酒店id（必填）	string
     * @param hotel_name 酒店名称（必填）	string
     * @param image_url 酒店首页图片url（必填）	string
     * @param low_rate 最低价格（也建议填上）	number
     * @param user_Id 用户id（必填）	number
     */
    XbedAPI.prototype.addElongCollect = function (param, token) {
        return this.xbedGatewayClient.addElongCollect(param, token);
    };
    /**
     * deleteCollect 删除艺龙收藏
     * @param hotel_id 酒店id（必填）	number
     * @param user_Id 用户id（必填）	number
     */
    XbedAPI.prototype.deleteCollect = function (hotelId, userId, token) {
        return this.xbedGatewayClient.deleteCollect(hotelId, userId, token);
    };
    /**
     * getAllCity 获取所有城市
     */
    XbedAPI.prototype.getAllCity = function () {
        return this.xbedGatewayClient.getAllCit();
    };
    /**
     * 高德api的adcode（国家标准code）转艺龙城市code
     * @param adcode	高德api的adcode（国家标准code）	string
     */
    XbedAPI.prototype.getCityCode = function (adcode) {
        return this.xbedGatewayClient.getCityCode(adcode);
    };
    /**
     * 查询订单列表（口令）V2
     * @param command 口令
     * @param commandName 口令姓名
     * @param commandPhone 口令手机
     * @param token
     */
    XbedAPI.prototype.commandCheckinList = function (command, commandName, commandPhone, token) {
        return this.xbedGatewayClient.commandCheckinList(command, commandName, commandPhone, token);
    };
    /**
     * 门店评论列表
     * @param page 页数
     * @param pageSize 每页数量
     * @param roomTypeId 房型ID
     * @param token
     */
    XbedAPI.prototype.queryRoomTypeRatingList = function (page, pageSize, roomTypeId) {
        return this.xbedGatewayClient.getRatingList(page, pageSize, roomTypeId);
    };
    /**
     * 房间评论列表
     * @param page
     * @param pageSize
     * @param roomId 房间ID
     */
    XbedAPI.prototype.queryRoomRatingList = function (page, pageSize, roomId) {
        return this.xbedGatewayClient.roomComment(page, pageSize, roomId);
    };
    /**
     * 个人中心首页
     *
     */
    XbedAPI.prototype.getHomePageInfo = function () {
        return this.xbedGatewayClient.getHomePageInfo();
    };
    /**
     * 新增用户反馈
     *
     *  @param checkinId 订单号。非必传
     *  @param content 反馈内容
     */
    XbedAPI.prototype.addFeedback = function (params, token) {
        return this.xbedGatewayClient.addFeedback(params, token);
    };
    /**
     * 首页接口
     *
     */
    XbedAPI.prototype.getHomePage = function () {
        return this.xbedGatewayClient.getHomePage();
    };
    /**
     * 上传client_id
     *
     *  @param clientId 客户端ID
     */
    XbedAPI.prototype.clientId = function (clientId, token) {
        return this.xbedGatewayClient.clientId(clientId, token);
    };
    /**
     * 是否可以人脸识别
     *
     */
    XbedAPI.prototype.canVerify = function (token) {
        return this.xbedGatewayClient.canVerify(token);
    };
    /**
     * 人脸识别验证（新微信端）
     *
     *  @param name
     *  @param phone
     *  @param mediaId
     *  @param userId 非必传
     *  @param idNo
     */
    XbedAPI.prototype.faceRecognition = function (userId, phone, mediaId, name, idNo, token) {
        if (token === void 0) { token = ''; }
        return this.xbedGatewayClient.faceRecog(name, phone, mediaId, userId, idNo, token);
    };
    /**
     * APP-UI设置参数接口
     *
     */
    XbedAPI.prototype.getAppUISetting = function () {
        return this.xbedGatewayClient.getAppUISetting();
    };
    /**
     * 识别身份证以验证身份
     *
     *  @param frontImg 正面照片
     *  @param type 类型。1-微信；2-APP
     *  @param backImg 背面照片
     */
    XbedAPI.prototype.ocrIDCard = function (frontImg, type, backImg, token) {
        return this.xbedGatewayClient.ocrIDCard(frontImg, type, backImg, token);
    };
    /**
     * 查询首页内容(Banner 精选房源)
     */
    XbedAPI.prototype.queryHomePageContent = function (token) {
        if (token === void 0) { token = ''; }
        return this.xbedGatewayClient.recommend(token);
    };
    /**
     * 获取Xbed的当前时间
     */
    XbedAPI.prototype.getXbedCurrTime = function () {
        return this.xbedGatewayClient.xbedCurrTime();
    };
    /**
     * 查询房间列表
     *
     * @param longitude 经度
     * @param rentType 租赁类型。默认值是3，长租和短租
     * @param isImmediateCheckin 是否即时入住。非必传，默认false
     * @param chainId 门店id
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）
     * @param bedroomNum 卧室数量。-1代表更多，不传代表不限
     * @param size 每页记录数
     * @param bedCount 床数。-1代表更多，不传代表不限
     * @param tradingArea 商圈的code
     * @param start 页码
     * @param endDate 离店日期 yyyy-MM-dd
     * @param maxPrice 价格最大值，单位分
     * @param latitude 纬度
     * @param startDate 入住日期 yyyy-MM-dd
     * @param district 区县的code
     * @param minPrice 价格最小值，单位分
     * @param city 城市名。必传
     * @param indiviTag 特色
     * @param orderBy 默认排序
     */
    XbedAPI.prototype.queryRoomList = function (params, token) {
        return this.xbedGatewayClient.searchRoomList(params, token);
    };
    /**
     * 获取房间、房型查询条件
     * @param city 城市（中文）
     */
    XbedAPI.prototype.getListConditions = function (city) {
        return this.xbedGatewayClient.queryRoomTag(city);
    };
    /**
     * 获取热门城市
     * @param num 热门城市数量
     * @param showPic 是否显示热门城市图片
     */
    XbedAPI.prototype.queryHotCity = function (num, showPic) {
        return this.xbedGatewayClient.listFixHotCity(num, showPic ? 1 : 0);
    };
    /**
     * 查询全部城市
     */
    XbedAPI.prototype.queryAllCities = function () {
        return this.xbedGatewayClient.listAllCity(true);
    };
    /**
     * 查询有房间的城市
     */
    XbedAPI.prototype.queryAllCitiesWithRooms = function () {
        return this.xbedGatewayClient.listAllCity(false);
    };
    /**
     * 查询房间详情信息V4
     * @param roomId 房间ID
     */
    XbedAPI.prototype.getRoomDetail = function (params) {
        return this.xbedGatewayClient.getRoomDetail(params);
    };
    /**
     * 查询美食套餐接口
     */
    XbedAPI.prototype.queryExploreList = function (page, size, token) {
        return this.xbedGatewayClient.recommendRoom(page, size, 3, token);
    };
    /**
     * 判断能否续住
     * @param checkinId
     * @param token
     */
    XbedAPI.prototype.verifyOverstay = function (checkinId, token) {
        return this.xbedGatewayClient.verifyOverstay(checkinId, token);
    };
    /**
     * 通过openId刷新用户卡券userId的信息
     * @param openId 微信openId
     */
    XbedAPI.prototype.refreshUserIdofCardWithOpenId = function (openId, token) {
        return this.xbedGatewayClient.refreshCardUserId(openId, token);
    };
    /**
     * 查询3个月内的远期房态
     * @param roomId 房间ID
     */
    XbedAPI.prototype.queryRoomStatusAfterThreeMonths = function (roomId) {
        return this.xbedGatewayClient.get3MonthRoomsStatus(roomId);
    };
    /**
     * 计算房间价格
     * @param activityId 指定执行活动id(不选择任何活动请传递 -1；首次访问不传递该字段)
     * @param beginDate 订单开始时间(isOverStay=1时传递，否则不传)
     * @param endDate 订单结束时间
     * @param cardCode 卡券code
     * @param checkinId 入住单Id(isOverStay=2时传递，否则不传)
     * @param flag flag=1时，会查询优惠券列表
     * @param isOverStay 1:订单,2:续住单
     * @param rentType 租房类型(1短租，2长租)
     * @param roomId 房间id
     * @param usedXdollar 用户用的xdollar
     */
    XbedAPI.prototype.roomPriceCalculate = function (params, token) {
        return this.xbedGatewayClient.calculatePrice(params, token);
    };
    /**
     * 创建房间订单 (非续住)
     * @param activityId 指定执行活动id(如果不想选择活动就传递-1)
     * @param arrivalTime 预计到达时间
     * @param beginDate 订单开始时间
     * @param cardCode 使用卡券code(非必传参数)
     * @param command 口令
     * @param commandName 口令姓名
     * @param commandPhone 口令手机
     * @param endDate 订单结束时间
     * @param isPackage 是否为打包房型下单(1:是 0:否)
     * @param name 用户下单时填写的称呼
     * @param rentType 租房类型 1短租，2 长租
     * @param roomId 多个房间数组或逗号隔开
     * @param roomTypeId 打包房型id
     * @param xdollar Xdollar的数量(非必传参数)
     */
    XbedAPI.prototype.createRoomOrder = function (params, token) {
        return this.xbedGatewayClient.createRoomOrder(params, token);
    };
    /**
     * 创建续住单
     * @param activityId 参加活动id 没有填写-1
     * @param beginDate 续住开始时间
     * @param endDate 续住结束时间
     * @param cardCode 卡券code（非必传）
     * @param checkinId checkinId
     * @param rentType 租房类型 1:短租 2:长租
     * @param xdollar xdollar的数量（非必传）
     * @param token
     */
    XbedAPI.prototype.createOverStayOrder = function (params, token) {
        return this.xbedGatewayClient.overStay(params, token);
    };
    /**
     * 获取微信支付参数（微信）
     * @param body xbed-酒店 Xbed-长租在住清洁费 Xbed-短租押金
     * @param checkinId 入住单号
     * @param openId 用户标识(微信端必传)
     * @param orderNo 订单号
     * @param payFor 支付源（1 支付订单金额 2 长租清洁单 3 短租押金 4 打包房型）
     * @param price 价格
     * @param systemName 系统名称 丽家会：XbClean, 艾佰德：Xbed
     * @param token
     */
    XbedAPI.prototype.getWechatPayParams = function (params, token) {
        return this.xbedGatewayClient.getWecPayParam(params, token);
    };
    /**
     * 获取银联支付参数
     * @param checkinId 入住单号
     * @param orderNo 订单号
     * @param payFor 支付源（1 支付订单金额 2 长租清洁单 3 短租押金 4 打包房型）
     * @param price 价格
     * @param systemName 系统名称 丽家会：XbClean, 艾佰德：Xbed
     * @param token
     */
    XbedAPI.prototype.getUnionPayParams = function (params, token) {
        return this.xbedGatewayClient.unionWapPay(params, token);
    };
    /**
     * 获取用户全部发票
     * @param page
     * @param size
     * @param token
     */
    XbedAPI.prototype.queryInvoiceList = function (page, size, token) {
        return this.xbedGatewayClient.findInvoiceList(page, size, token);
    };
    /**
     * 可开发票订单列表
     * @param page
     * @param size
     * @param token
     */
    XbedAPI.prototype.queryAvailableInvoiceList = function (page, size, token) {
        return this.xbedGatewayClient.canInvoiceOrderList(page, size, token);
    };
    /**
     * 获取用户发票基础信息
     * @param token
     */
    XbedAPI.prototype.getInvoiceInfo = function (token) {
        return this.xbedGatewayClient.invoiceInfo(token);
    };
    /**
     * 开具普通发票
     * @param addressId 地址ID
     * @param orderNos 订单号
     * @param price 开票金额
     * @param token
     */
    XbedAPI.prototype.createNormalInvoice = function (addressId, orderNos, price, token) {
        return this.xbedGatewayClient.saveInvoice(addressId, orderNos, price, token);
    };
    /**
     * 开具电子发票
     * @param addressId 地址ID
     * @param orderNos 订单号
     * @param phone 手机号码
     * @param price 开票金额
     * @param token
     */
    XbedAPI.prototype.createElectronicInvoice = function (addressId, orderNos, phone, price, token) {
        return this.xbedGatewayClient.saveElecInvoice(addressId, orderNos, phone, price, token);
    };
    /**
     * 创建普通发票收件人
     * @param address 详细地址
     * @param city 市ID
     * @param code 邮编（可选）
     * @param county 地区ID
     * @param phone 收件人手机号码
     * @param province 省ID
     * @param realname 收件人真实姓名
     * @param taxpayerId 纳税人税号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业
     * @param token
     */
    XbedAPI.prototype.createNormalInvoiceReceiver = function (params, token) {
        return this.xbedGatewayClient.invoiceAddReceiver(params, token);
    };
    /**
     * 修改发票收件人
     * @param address 详细地址
     * @param addressId 地址ID
     * @param city 市ID
     * @param code 邮编（可选）
     * @param county 地区ID
     * @param phone 收件人手机号码
     * @param province 省ID
     * @param realname 收件人真实姓名
     * @param taxpayerId 纳税人税号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业
     * @param token
     */
    XbedAPI.prototype.updateNormalInvoiceReceiver = function (params, token) {
        return this.xbedGatewayClient.invoiceUpdateReceiver(params, token);
    };
    /**
     * 删除发票收件人
     * @param addressId 地址ID
     * @param token
     */
    XbedAPI.prototype.removeNormalInvoiceReceiver = function (addressId, token) {
        return this.xbedGatewayClient.invoiceDelReceiver(addressId, token);
    };
    /**
     * 创建电子发票地址
     * @param email 接收发票的邮箱
     * @param taxpayerId 纳税人识别号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业；
     * @param token
     */
    XbedAPI.prototype.createElectronicInvoiceReceiver = function (params, token) {
        return this.xbedGatewayClient.invoiceSaveElecInvoiceInfo(params, token);
    };
    /**
     * 编辑电子发票地址
     * @param addressId 地址ID
     * @param email 接收发票的邮箱
     * @param taxpayerId 纳税人识别号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业；
     * @param token
     */
    XbedAPI.prototype.updateElectronicInvoiceReceiver = function (params, token) {
        return this.xbedGatewayClient.invoiceEditElecInvoiceInfo(params, token);
    };
    /**
     * 删除电子发票地址
     * @param addressId 地址ID
     * @param token
     */
    XbedAPI.prototype.removeElectronicInvoiceReceiver = function (addressId, token) {
        return this.xbedGatewayClient.invoiceDelElecInvoiceInfo(addressId, token);
    };
    /**
     * 查询旅游攻略列表
     * @param params
     */
    XbedAPI.prototype.queryTravelList = function (params) {
        var queryParams = params;
        queryParams.column = 4;
        return this.xbedGatewayClient.articleList(queryParams);
    };
    /**
     * 微信js sdk 参数
     * @param url 应用域名
     */
    XbedAPI.prototype.getJSSDKConfig = function (currUrl) {
        return this.xbedGatewayClient.jsapiTicket(currUrl);
    };
    /**
     * 地图模式展示楼宇V4
     * @param city 对应热门城市。必传
     * @param startDate 入住时间。yyyy-MM-dd
     * @param endDate 离店时间。yyyy-MM-dd
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）
     * @param isImmediateCheckin 	是否马上入住。true
     * @param rentType 租赁类型。1-短租；2-长租
     */
    XbedAPI.prototype.queryBuildingsOnMap = function (params) {
        return this.xbedGatewayClient.getMapBuilding(params);
    };
    /**
     * 查询用户入住信息
     * @param isPrivate 七牛是否是私有空间。1-是私有空间；0-不是
     * @param phone 入住人手机号
     * @param token
     */
    XbedAPI.prototype.getCheckinPerson = function (isPrivate, phone, token) {
        return this.xbedGatewayClient.findCheckinPerson(isPrivate, phone, token);
    };
    /**
     * 查询卡券列表
     * @param token
     */
    XbedAPI.prototype.getCouponCardList = function (token) {
        return this.xbedGatewayClient.getCouponCardList(token);
    };
    /**
     * 兑换优惠券
     * @param code 优惠码
     * @param token
     */
    XbedAPI.prototype.getPreferentialCode = function (code, token) {
        return this.xbedGatewayClient.getPreferentialCode(code, token);
    };
    /**
     * 获取活动列表
     * @param page 页码
     * @param size 每页记录条数
     * @param token
     */
    XbedAPI.prototype.getActivityList = function (page, size, token) {
        return this.xbedGatewayClient.getActivityList(page, size, token);
    };
    /**
     * 获取活动列表v2
     * @param page 页码
     * @param size 每页记录条数
     * @param token
     */
    XbedAPI.prototype.getActivityListV2 = function (page, size, token) {
        return this.xbedGatewayClient.getActivityListV2(page, size, token);
    };
    /**
     * 修改用户信息
     * @param email 用户邮箱
     * @param headImage 用户头像
     * @param headImgMediaId 微信端头像的mediaId
     * @param openId 微信平台用户唯一标识
     * @param realname	用户姓名
     * @param remark	备注
     * @param token
     */
    XbedAPI.prototype.updateUserInfo = function (params, token) {
        return this.xbedGatewayClient.updateUserInfo(params, token);
    };
    /**
     * 获取code的Url
     * @param url
     */
    XbedAPI.prototype.getWechatCodeUrl = function (codeUrl) {
        return this.xbedGatewayClient.getCodeUrl(codeUrl);
    };
    /**
     * 获取openId
     * @param code
     */
    XbedAPI.prototype.getWechatOpenId = function (code) {
        return this.xbedGatewayClient.getOpenId(code);
    };
    /**
     * 查询入住单详情V4(增加房型打包后需要更新的订单列表接口)
     * @description 只有isPackage=1（打包房型订单）并且type=1（待支付）的情况，才调用此接口
     * @param orderNo 订单号
     * @param token
     */
    XbedAPI.prototype.queryOrderDetailWithSpecialty = function (orderNo, token) {
        return this.xbedGatewayClient.checkinOrderInfoWithSpecialty(orderNo, token);
    };
    /**
     * 查询入住单详情V3
     * @description 实付金额在前台进行计算：实付金额 =（price-discount）
     * @param checkinId 入住单Id
     * @param token
     */
    XbedAPI.prototype.queryOrderDetailWithCommon = function (checkinId, token) {
        return this.xbedGatewayClient.checkinOrderInfoWithCommon(checkinId, token);
    };
    /**
     * 获取待评论订单数据
     * @param page 页码
     * @param size 每页大小
     * @param token
     */
    XbedAPI.prototype.getWaitEvaluate = function (page, size, token) {
        return this.xbedGatewayClient.waitEvaluate(page, size, token);
    };
    /**
     * 获取是否有待评论订单标识接口
     * @param token
     */
    XbedAPI.prototype.getWaitEvaluateFlag = function (token) {
        return this.xbedGatewayClient.waitEvaluateFlag(token);
    };
    /**
     * 取消入住单
     * @param checkinId 入住单Id（非必传字段）
     * @param orderNo 订单号
     * @param token
     */
    XbedAPI.prototype.cancelCheckinOrder = function (params, token) {
        return this.xbedGatewayClient.cancelCheckinOrder(params, token);
    };
    /**
     * 取消续住单
     * @param checkinInfoId 	子入住单id
     * @param token
     */
    XbedAPI.prototype.cancelCheckinInfoOrder = function (checkinInfoId, token) {
        return this.xbedGatewayClient.cancelCheckinInfoOrder(checkinInfoId, token);
    };
    /**
     * 办理退房
     * @param checkinId 入住单Id
     * @param roomId 房间Id
     * @param token
     */
    XbedAPI.prototype.checkout = function (checkinInfoId, roomId, token) {
        return this.xbedGatewayClient.checkout(checkinInfoId, roomId, token);
    };
    /**
     * 检查是否需要支付押金(原checkin v1)
     * @param checkinId
     * @param token
     */
    XbedAPI.prototype.queryCheckinStatus = function (checkinId, token) {
        return this.xbedGatewayClient.queryCheckinStatus(checkinId, token);
    };
    /**
     * 办理入住V2
     * @param checkinId 入住单号
     * @param token
     */
    XbedAPI.prototype.checkin = function (checkinId, token, machineNumber) {
        if (machineNumber === void 0) { machineNumber = ''; }
        return this.xbedGatewayClient.checkin(checkinId, token, machineNumber);
    };
    /**
     * 判断是否可申请在住清洁
     * @param checkinId 入住单Id
     * @param orderNo 订单号
     * @param token
     */
    XbedAPI.prototype.checkinClean = function (checkinId, orderNo, token) {
        return this.xbedGatewayClient.checkinClean(checkinId, orderNo, token);
    };
    /**
     * 提交在住清洁申请
     * @param checkinId 入住单详情
     * @param itemDetail 项目明细
     * @param orderNo 订单号
     * @param roomId 房间Id
     * @param time 时间Id
     * @param token
     */
    XbedAPI.prototype.submitClean = function (checkinId, itemDetail, orderNo, roomId, time, token) {
        return this.xbedGatewayClient.submitClean(checkinId, itemDetail, orderNo, roomId, time, token);
    };
    /**
     * 取消在住清洁单
     * @param checkinId 入住单Id
     * @param orderNo 订单号
     * @param token
     */
    XbedAPI.prototype.cancleCheckinClean = function (checkinId, orderNo, token) {
        return this.xbedGatewayClient.cancleCheckinClean(checkinId, orderNo, token);
    };
    /**
     * 提交清洁评价
     * @param checkinId 入住单id
     * @param cleanContent 清洁评价内容
     * @param cleanStarId 清洁评价星级
     * @param cleanTermIdList 清洁评价标签集合
     * @param content 评价内容（老版本）
     * @param mediaIdList 微信端传递
     * @param orderNo 订单号
     * @param roomContent 房间评价内容
     * @param roomId 房间Id
     * @param roomStarId 房间评价星级
     * @param roomTermIdList 房间评价标签集合
     * @param securityContent 安全感评价内容
     * @param securityStarId 安全感评价星级
     * @param securityTermIdList 安全感评价标签集合
     * @param starId 星Id
     * @param termIdList 标签Id列表(非必传)
     * @param token
     */
    XbedAPI.prototype.submitCleanEvaluate = function (params, token) {
        return this.xbedGatewayClient.submitCleanEvaluate(params, token);
    };
    /**
     * 远程开门
     * @param idCard 身份证后6位
     * @param roomId 房间Id
     * @param validVal 验证码
     * @param token
     */
    XbedAPI.prototype.openDoor = function (idCard, roomId, validVal, token) {
        return this.xbedGatewayClient.openDoor(idCard, roomId, validVal, token);
    };
    /**
     * 获取用户推广相关信息
     */
    XbedAPI.prototype.queryPopularizeInfo = function (token) {
        return this.xbedGatewayClient.userPopularizeInfo(token);
    };
    /**
     * 保存用户推广相关信息
     * @param bankName 银行名称
     * @param bankNo 银行卡号
     * @param bankSignName 户名
     * @param phone 手机号
     * @param verifyCode 短信验证码
     * @param token
     */
    XbedAPI.prototype.updatePopularizeInfo = function (params, token) {
        return this.xbedGatewayClient.savePopularizeInfo(params, token);
    };
    /**
     * 获取房间评价信息v4 evaluated：用户已评价返回评价内容信息 overdue：评价过期返回用户默认评价信息 waitEvaluate：未评价时返回评价参数
     * @param checkinId 入住单Id
     * @param roomId 房间Id
     * @param token
     */
    XbedAPI.prototype.getRoomComment = function (checkinId, roomId, token) {
        return this.xbedGatewayClient.getRoomComment(checkinId, roomId, token);
    };
    /**
     * 房间评价
     * @param checkinId 入住单id
     * @param cleanContent 清洁评价内容(新版本)
     * @param cleanStarId 清洁评价星级
     * @param cleanTermIdList 清洁评价标签集合
     * @param flag 标记是否返回评价数据
     * @param mediaIdList 微信端传递
     * @param roomContent 房间评价内容
     * @param roomStarId 房间评价星级
     * @param roomTermIdList 房间评价标签集合
     * @param securityContent 安全感评价内容
     * @param securityStarId 安全感评价星级
     * @param securityTermIdList 安全感评价标签集合
     * @param token
     */
    XbedAPI.prototype.addRoomComment = function (params, token) {
        return this.xbedGatewayClient.addRoomComment(params, token);
    };
    /**
     * 是否可以重置超级密码
     * @param roomId 房间id
     * @param token
     */
    XbedAPI.prototype.canResetPwd = function (roomId, token) {
        return this.xbedGatewayClient.canResetPwd(roomId, token);
    };
    /**
     * 入住单密码重置
     * @param checkinId 入住单id
     * @param roomId 房间id
     * @param validVal 验证码
     * @param token
     */
    XbedAPI.prototype.resetPwd = function (checkinId, roomId, validVal, token) {
        return this.xbedGatewayClient.resetPwd(checkinId, roomId, validVal, token);
    };
    /**
     * 重置密码获取验证码
     * @param checkinId 入住单id
     * @param idCard 身份证后6位
     * @param isText true-文字短信；false-语音短信
     * @param token
     */
    XbedAPI.prototype.getVerifyCodeForResetPwd = function (checkinId, idCard, isText, token) {
        return this.xbedGatewayClient.getVerifyCodeForResetPwd(checkinId, idCard, isText, token);
    };
    /**
     * 点击楼宇获取房间列表V4
     *
     * @param beginDate 入住时间
     * @param endDate 离店时间
     * @param buildingId 楼宇ID
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）
     * @param isImmediateCheckin 是否即时入住
     * @param rentType 1-短租；2-长租
     * @param token
     */
    XbedAPI.prototype.queryRoomsFromBuilding = function (params) {
        return this.xbedGatewayClient.getRoomsByBuilding(params);
    };
    /**
     * 模糊搜索多个子节点V4
     * @param city 城市
     * @param keyword 搜索关键字
     */
    XbedAPI.prototype.searchMoreSubAllTag = function (city, keyword) {
        return this.xbedGatewayClient.searchMoreSubAllTag(city, keyword);
    };
    /**
     * 删除入住人信息
     * @param id 入住人ID(checkinerId)
     * @param infoId 入住人信息ID
     * @param orderNo 订单号
     * @param token
     */
    XbedAPI.prototype.delCheckinPerson = function (id, infoId, orderNo, token) {
        return this.xbedGatewayClient.delCheckinPerson(id, infoId, orderNo, token);
    };
    /**
     * 用户身份验证
     * @param token
     */
    XbedAPI.prototype.getAuthentication = function (token) {
        return this.xbedGatewayClient.getAuthentication(token);
    };
    /**
     * 根据token查询用户信息
     */
    XbedAPI.prototype.queryUserInfo = function (token) {
        return this.xbedGatewayClient.findByToken(token);
    };
    /**
     * 查询押金是否支付
     * @param checkinId 入住单ID
     *
     */
    XbedAPI.prototype.queryHasPayShortGuarentee = function (checkinId) {
        return this.xbedGatewayClient.queryHasPayShortGuarentee(checkinId);
    };
    /**
     * 根据入住单ID查询扣款项详情
     * @param checkinId 入住单ID
     * @param token
     */
    XbedAPI.prototype.queryRefundShortDetail = function (checkinId, token) {
        return this.xbedGatewayClient.queryRefundShortDetail(checkinId, token);
    };
    /**
     * 获取开门密码
     * @param checkinId 入住单Id
     */
    XbedAPI.prototype.getOpenSecret = function (checkinId) {
        return this.xbedGatewayClient.getOpenSecret(checkinId);
    };
    /**
     * 距离判断是否可以人脸或指纹开门
     * @param distance 	可以开门的距离
     * @param location  	用户经纬度
     * @param roomLocation 房间经纬度（入住单详情有）
     */
    XbedAPI.prototype.queryIsOpenDoor = function (distance, location, roomLocation) {
        return this.xbedGatewayClient.queryIsOpenDoor(distance, location, roomLocation);
    };
    /**
     * 人脸开门
     * @param imageFace 上传的图片地址
     * @param roomId 房间id
     * @param type  1 微信 2 url
     * @param userId  用户ID
     */
    XbedAPI.prototype.isFaceOpenDoor = function (handlerName, imageFace, roomId, type, userId) {
        return this.xbedGatewayClient.isFaceOpenDoor(handlerName, imageFace, roomId, type, userId);
    };
    /**
     * 1、身份证验证 2、人脸识别验证
     *
     * @param frontImg 身份证正面图片
     * @param backImg 身份证背面图片
     * @param imageFace 人脸图片
     * @param imgType 图片获取方式 1、从微信的素材ID 2、七牛url
     * @param name 姓名
     * @param phone 电话
     * @param type 1、身份证 2、人脸
     * @param userId
     * @param token
     */
    XbedAPI.prototype.queryIdCardAndFaceRecognition = function (params, token) {
        return this.xbedGatewayClient.queryIdCardAndFaceRecognition(params, token);
    };
    /**
     * 港澳台/外籍人士身份验证
     * @param certificateAuditStatus 证件审核状态
     * @param certificateIdNo 证件号
     * @param certificateValid 证有效日期
     * @param certificateType 证件类型
     * @param image1 证正面
     * @param image2 人脸正面
     * @param imageType 图片获取方式 1、从微信的素材ID 2、七牛url
     * @param name 姓名
     * @param userId
     * @param token
     */
    XbedAPI.prototype.queryOtherCertificateRecognition = function (params, token) {
        return this.xbedGatewayClient.queryOtherCertificateRecognition(params, token);
    };
    /**
     * 根据微信上传图片返回的serverId获得七牛图片地址
     * @param serverId 微信上传图片返回的serverId
     * @param token
     */
    XbedAPI.prototype.wechatServerIdToQiNiuUrl = function (serverId, token) {
        return this.xbedGatewayClient.wechatServerIdToQiNiuUrl(serverId, token);
    };
    /**
     * 根据手机号查询查询企业员工
     * @param mobile 	员工电话
     */
    XbedAPI.prototype.queryIsEnterpriseEmployees = function (mobile) {
        return this.xbedGatewayClient.queryIsEnterpriseEmployees(mobile);
    };
    /**
     * 获取卡卷（活动）到期未读提醒数量
     */
    XbedAPI.prototype.findCardCount = function () {
        return this.xbedGatewayClient.findCardCountByToken();
    };
    /**
     * 触发更新活动已读
     * @param type 更新状态的类型 card卡券,activity活动,必传
     */
    XbedAPI.prototype.updateActivityReaded = function (type) {
        return this.xbedGatewayClient.updateActivityDoReaded(type);
    };
    /**
     * 办理入住-寻求帮助 获取密码
     * @param checkinId id字符串（，分隔）
     */
    XbedAPI.prototype.getCheckinPassword = function (checkinId) {
        return this.xbedGatewayClient.getCheckinRoomPassword(checkinId);
    };
    /**
     * 办理入住-寻求帮助 获取验证码
     */
    XbedAPI.prototype.createOpenDoorCode = function () {
        return this.xbedGatewayClient.createOpenDoorCode();
    };
    /**
     * 远程开门
     * @param handlerName 手机号+订单号 mock phone_13797987456_order_43214123412
     * @param roomId 房价id
     */
    XbedAPI.prototype.openRoomLock = function (handlerName, roomId, token) {
        return this.xbedGatewayClient.openRoomLock(handlerName, roomId, token);
    };
    /**
     * 使用用户 token 换取上传七牛的 token
     * @param source
     * @param isPrivate
     */
    XbedAPI.prototype.getUploadToken = function (params, token) {
        return this.xbedGatewayClient.getUploadToken(params, token);
    };
    /**
     * 七牛私有图片转换成可访问的地址
     * @param imgUrl 七牛私有地址
     * @param token
     */
    XbedAPI.prototype.queryQiniuPrivateImageUrl = function (imgUrl, token) {
        return this.xbedGatewayClient.queryQiniuPrivateImageUrl(imgUrl, token);
    };
    /**
     * 注册
     * @param phone 手机号码
     * @param source 注册来源
     */
    XbedAPI.prototype.registerForLanding = function (phone, source) {
        return this.xbedGatewayClient.registerForLanding(phone, source);
    };
    /**
     * 添加创客信息和签约意向对象
     * @param decorateLevel 装修等级0无1毛坯2简装3精装
     * @param email 电子邮箱
     * @param idCard 身份证号码
     * @param investIntention 投资意向0无1计划找房2现持有房源
     * @param name 姓名
     * @param oneBedroomNum 一居室数量
     * @param otherBedroomNum 其他数量
     * @param phone 手机号
     * @param propertyCity 物业城市
     * @param propertyDistrict 物业区域
     * @param propertyProvince 物业省份
     * @param residentCity 常驻城市
     * @param residentDistrict 常驻区域
     * @param residentProvince 常驻省份
     * @param threeBedroomNum 三居室数量
     * @param twoBedroomNum 二居室数量
     */
    XbedAPI.prototype.addXbedMaker = function (params) {
        return this.xbedGatewayClient.addXbedMaker(params);
    };
    /**
     * 检查手机号码是否注册
     * @param phone 手机号码
     */
    XbedAPI.prototype.isRegister = function (phone) {
        return this.xbedGatewayClient.isRegister(phone);
    };
    /**
     * 获取房客，房东文章列表
     * @param page 页码
     * @param pageSize 每页数据
     * @param type 文章类型，6 房东故事、7房客故事
     * @param terminal 平台类型  pc、ios、android、wechat
     */
    XbedAPI.prototype.getArticle = function (page, pageSize, type, terminal) {
        return this.xbedGatewayClient.getArticle(page, pageSize, type, terminal);
    };
    /**
     * 获取房间寻路指南位置信息
     * @param rentType 租赁类型
     * @param roomId 房间id
     */
    XbedAPI.prototype.getRoomNavigationInfo = function (rentType, roomId) {
        return this.xbedGatewayClient.getRoomNavigationInfo(rentType, roomId);
    };
    /**
     * 获取房间寻路指南位置信息
     * @param rentType 租赁类型
     * @param roomId 房间id
     */
    XbedAPI.prototype.getChainNavigationInfo = function (rentType, roomTypeId) {
        return this.xbedGatewayClient.getChainNavigationInfo(rentType, roomTypeId);
    };
    /**
     * 办理入住校验身份（订单列表办理入住）
     * @param checkinId
     * @param roomId
     */
    XbedAPI.prototype.checkLoginUserIdentity = function (checkinId, roomId) {
        return this.xbedGatewayClient.checkLoginUserIdentity(checkinId, roomId);
    };
    /**
     * 在首页查询是否跳转到订单列表页 或者 跳转到订单详情页
     */
    XbedAPI.prototype.queryCheckinHomeList = function () {
        return this.xbedGatewayClient.queryCheckinHomeList();
    };
    /**
     * 无人入住酒店 二维码扫码次数更新
     */
    XbedAPI.prototype.noOneQrCodeUpdate = function (url, parmas, token) {
        return this.xbedGatewayClient.noOneQrCodeUpdate(url, parmas, token);
    };
    /**
     * 首页查询当天订单 或者 跳转到订单详情页
     */
    XbedAPI.prototype.queryNowOrder = function (token) {
        return this.xbedGatewayClient.queryNowOrder(token);
    };
    /**
     * 分页搜索门店
     */
    XbedAPI.prototype.queryRoomInfo = function (params) {
        return this.xbedGatewayClient.queryRoomInfo(params);
    };
    /**
     * 搜索门店
     */
    XbedAPI.prototype.queryAllRoomInfo = function (params) {
        return this.xbedGatewayClient.queryAllRoomInfo(params);
    };
    /**
     * 获取百度活力验证access_token
     */
    XbedAPI.prototype.getLivingAccessToken = function (token) {
        return this.xbedGatewayClient.getLivingAccessToken(token);
    };
    /**
     * 修改用户身份验证状态
     */
    XbedAPI.prototype.modifyRegStatus = function (url, userId, state, idCheckResult, token) {
        return this.xbedGatewayClient.modifyRegStatus(url, userId, state, idCheckResult, token);
    };
    /**
     * 退房开门接口
     * @param handlerName 开门原因(必填)
     * @param imageFace 人脸图片上传到七牛服务器后返回的url
     * @param latitude 	纬度(必填)
     * @param longitude 	经度(必填)
     * @param roomId 房间id(必填)
     * @param type 人脸开门的类型标记（1大陆身份证， 2港澳台）
     */
    XbedAPI.prototype.overOpenDoor = function (handlerName, imageFace, latitude, longitude, roomId, type, token) {
        return this.xbedGatewayClient.overOpenDoor(handlerName, imageFace, latitude, longitude, roomId, type, token);
    };
    return XbedAPI;
}());
exports.XbedAPI = XbedAPI;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/xbed-api.js
// module id = 226
// module chunks = 44